module.exports = "<div class=\"m-grid__item m-grid__item--fluid  m-grid m-grid--ver\tm-container m-container--responsive m-container--xxl m-page__container\">\n\t<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\n\t\t<router-outlet></router-outlet>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/aside-left-display-disabled.component.html
// module id = ../../../../../src/app/theme/pages/aside-left-display-disabled/aside-left-display-disabled.component.html
// module chunks = main